import React from "react";
import {validateForm} from "../../Components/ValidateForm/Validator";
import {useTranslation} from "react-i18next";
const EditCompanyHead = ({ show, handleClose, formData, handleInputChange, handleSave }) => {
    const {t} = useTranslation();
    const handleValidatedSave = () => {
        let errors = validateForm(formData, t);
        if (errors.length > 0) {
            alert(errors.join("\n"));
            return;
        }
        handleSave();
    };

    return (
        <div
            className={`modal fade ${show ? "show" : ""}`}
            id="editModal"
            tabIndex="-1"
            aria-labelledby="editModalLabel"
            style={{ display: show ? "block" : "none" , background: "rgba(0, 0, 0, 0.65)"}}
        >
            <div className="modal-dialog" style={{maxWidth:"700px"}}>
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="editModalLabel">
                            {t('edit_head_info')}
                        </h5>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={handleClose}
                        ></button>
                    </div>
                    <div className="modal-body">
                        <div className="container-fluid" style={{width: "1200px"}}>
                            <div className="row">
                                <div className="col-6">
                                    <div className="mb-3">
                                        <label htmlFor="fio" className="form-label">
                                            {t('translation:head_fio')}
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="fio"
                                            name="fio"
                                            value={formData?.fio || ""}
                                            onChange={handleInputChange}
                                            placeholder={t('translation:head_fio')}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="phone" className="form-label">
                                            {t('translation:head_phone')}
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="phone"
                                            name="phone"
                                            value={formData?.phone || ""}
                                            onChange={handleInputChange}
                                            placeholder={t('translation:head_phone')}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="email" className="form-label">
                                            {t('translation:head_email')}
                                        </label>
                                        <input
                                            type="email"
                                            className="form-control"
                                            id="email"
                                            name="email"
                                            value={formData?.email || ""}
                                            onChange={handleInputChange}
                                            placeholder={t('email')}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={handleClose}>
                            {t('translation:cancel')}
                        </button>
                        <button type="button" className="btn btn-primary" onClick={handleValidatedSave}>
                            {t('translation:save')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditCompanyHead;
